// Identifier types offered by the create-affiliate form, plus the input
// label/placeholder copy keyed off each type. Kept in the domain layer (no
// React deps) so it can be unit-tested without pulling the form component's
// transitive imports (the Dynamic SDK chain fails jest's `.cjs` transform).

export type AffiliateIdentifierType =
  | 'evm_address'
  | 'solana_address'
  | 'sui_address'
  | 'xrpl_address'
  | 'stellar_address'
  | 'email';

export const IDENTIFIER_TYPE_OPTIONS: { value: AffiliateIdentifierType; label: string }[] = [
  { value: 'evm_address', label: 'EVM Address' },
  { value: 'solana_address', label: 'Solana Address' },
  { value: 'sui_address', label: 'SUI Address' },
  { value: 'xrpl_address', label: 'XRPL Address' },
  { value: 'stellar_address', label: 'Stellar Address' },
  { value: 'email', label: 'Email' },
];

export const IDENTIFIER_LABELS: Record<string, string> = {
  evm_address: 'EVM Address',
  solana_address: 'Solana Address',
  sui_address: 'SUI Address',
  xrpl_address: 'XRPL Address',
  stellar_address: 'Stellar Address',
  email: 'Email Address',
};

export const IDENTIFIER_PLACEHOLDERS: Record<string, string> = {
  evm_address: 'e.g. 0x1234...abcd',
  solana_address: 'e.g. 7xKX...3nFh',
  sui_address: 'e.g. 0x8a2f...9c1e',
  xrpl_address: 'e.g. rN7m...xKvB',
  stellar_address: 'e.g. GBRP...7OX2H',
  email: 'e.g. user@example.com',
};

export function getIdentifierLabel(type: string | undefined): string {
  return IDENTIFIER_LABELS[type ?? ''] ?? 'Wallet Address';
}

export function getIdentifierPlaceholder(type: string | undefined): string {
  return IDENTIFIER_PLACEHOLDERS[type ?? ''] ?? 'e.g. 0x1234...abcd';
}
